const colors = {
  black: "#000000",
  white: "#ffffff",
  creditsGrey: "#8B8B8B",
  outlineGrey: "#e5e5e5",
  pink: "#E373FF",
}

export default colors
